import {clearAllCheckbox, getFormData, toArray} from "../helpers/operators.js";
import {sendPostAjax} from "../helpers/sendAjax.js";
import {multipleAccountsDropdown, multipleAccountsRadio} from "../helpers/templates.js";
import {Validator, ValidatorFns} from "../helpers/validators.js";

const AUTH_BLOCKS = {
    LOGIN: '.js-login',
    RESET_PASSWORD: '.js-reset',
    MULTIPLE_ACCOUNTS: '.js-multiple-accounts',
    CUSTOMER_BLOCKED: '.js-customer-blocked-wrapper'
}

export default function () {
    const authWrapper = document.querySelectorAll('.js-auth-modal-wrapper')[0];

    const loginUrl = document.querySelectorAll('.js-url')[0]?.value;
    const loginForm = document.querySelectorAll('.js-login-form')[0];
    const loginFormData = loginForm?.querySelectorAll('input') ?? [];
    const errorMsg = document.querySelectorAll('.js-auth-error')[0];

    const validatorMsg = {
        j_username: {
            required: 'Nödvändig',
            email: 'Vänligen ange en korrekt e-postadress: namn.efternamn@email.com',
        },
        j_password: {
            required: 'Nödvändig',
        }
    };

    const validator = Validator.validate({
        j_username: [ValidatorFns.required, ValidatorFns.email],
        j_password: [ValidatorFns.required],
    }, validatorMsg)
    
    const resetForm = document.querySelectorAll('.js-reset-pass-form')[0];
    const resetFormData = document.querySelectorAll('.js-reset-pass-form input');
    const goToResetPass = document.querySelectorAll('.js-go-to-reset-pass')[0];

    const multipleAccBody = document.querySelectorAll('.js-multiple-accounts-body')[0];
    const multipleAccForm = document.querySelectorAll('.js-multiple-accounts-form')[0];

    const customerBlockedWrapper = document.querySelectorAll('.js-customer-blocked-wrapper')[0];

    let userIdEl;
    let multipleAccCancelHandler;
    let customerPurchaseBlockedCancelHandler;
    let customerPurchaseBlockedOkHandler;
    let customerPurchaseBlockedDismissHandler;

    resetForm.addEventListener('submit', e => {
        e.preventDefault();
        sendPostAjax('/login/pw/request', getFormData(resetFormData), function (){
            $("#message-template").removeClass("hidden");
            $(".reset-pass-container").addClass("hidden");
            authWrapper?.classList.add("success-msg");
            authWrapper?.classList.remove('no-bg');
            ACC.colorbox.resize();
        });
    });

    loginForm.addEventListener('submit', e => {
        e.preventDefault();
        errorMsg.style.display = 'none';

        const hasErrors = validator(toArray(loginFormData));

        if (!hasErrors) {
            const rememberMe = loginForm.querySelector('.js-remember-me');
            rememberMe.value = true;

            sendPostAjax(loginUrl, getFormData(loginForm), successLoginHandler, errLoginHandler);
        }
    });

    const successLoginHandler = (htmlResponse) => {
        const html = parseHTML(htmlResponse);
        const childCustomers = toArray(html.querySelectorAll('.js-main-header .js-child-account')).map(el => el.dataset);

        if (childCustomers.length > 0) {
            userIdEl = html.querySelectorAll('.js-user-uid')[0];
            multipleAccBody.innerHTML = childCustomers.length > 4 ? multipleAccountsDropdown(childCustomers) : multipleAccountsRadio(childCustomers);
            showAuthBlock(AUTH_BLOCKS.MULTIPLE_ACCOUNTS);
            setMultipleAccOnCancelHandler();
        } else {
            userIdEl = null;

            let customerPurchaseBlocked = html.querySelectorAll('.js-customer-purchase-blocked');
            if(customerPurchaseBlocked.length > 0) {
                customerBlockedWrapper.appendChild(customerPurchaseBlocked[0]);
                showAuthBlock(AUTH_BLOCKS.CUSTOMER_BLOCKED);
                setCustomerPurchaseBlockedHandlers();
            } else {
                redirectAfterLogin();
            }
        }
    };

    const setCustomerPurchaseBlockedHandlers = () => {
        authWrapper?.addEventListener('click', e => e.stopPropagation());

        if (!customerPurchaseBlockedCancelHandler) {
            customerPurchaseBlockedCancelHandler = document.querySelectorAll('.js-auth-modal')[0]?.addEventListener('click', () => {
                redirectAfterLogin();
            });
        }

        if(!customerPurchaseBlockedOkHandler) {
            customerPurchaseBlockedOkHandler = document.querySelectorAll('.js-auth-modal .js-customer-purchase-blocked-ok')[0]?.addEventListener('click', () => {
                redirectAfterLogin();
            });
        }

        if(!customerPurchaseBlockedDismissHandler) {
            customerPurchaseBlockedDismissHandler = document.querySelectorAll('.js-auth-modal .js-dismiss-auth-modal')[0]?.addEventListener('click', () => {
                redirectAfterLogin();
            });
        }
    };

    const redirectAfterLogin = () => {
        if (multipleAccCancelHandler) {
            multipleAccCancelHandler.removeEventListener();
        }

        if(window.location.href.indexOf("login") >= 0){
            window.location.href = "../../../../../..";
            return;
        }

        window.location.reload();
    };

    const parseHTML = html => {
        const el = document.createElement('div');
        el.innerHTML = html;
        return el;
    }

    const setMultipleAccOnCancelHandler = () => {
        if (multipleAccCancelHandler) {
            return;
        }

        authWrapper?.addEventListener('click', e => e.stopPropagation());

        multipleAccCancelHandler = document.querySelectorAll('.js-auth-modal')[0]?.addEventListener('click', () => {
            window.location.reload();
        });
    }

    const showAuthBlock = showBlockClass => {
        const blockClassesArr = Object.values(AUTH_BLOCKS);

        document.querySelectorAll(showBlockClass)[0].style.display = 'block';

        for (let blockClass of blockClassesArr) {
            if (blockClass !== showBlockClass) {
                document.querySelectorAll(blockClass)[0].style.display = 'none';
            }
        }
    }

    const errLoginHandler = () => errorMsg.style.display = 'block';

    multipleAccForm?.addEventListener('submit', e => {
        e.preventDefault();
        e.stopPropagation();
        const multipleAccFormData = [
            userIdEl,
            ...toArray(document.querySelectorAll('.js-multiple-accounts-form input')),
            ...toArray(document.querySelectorAll('.js-multiple-accounts-form select')),
        ];

        sendPostAjax(loginUrl, getFormData(multipleAccFormData), successLoginHandler, errLoginHandler);
    });

    goToResetPass.addEventListener('click', () => {
        showAuthBlock(AUTH_BLOCKS.RESET_PASSWORD)
        authWrapper?.classList.add('no-bg');
        resetAll();
    });

    const resetAll = () => {
        clearAllCheckbox(loginFormData);
        Validator.clearInputs(loginFormData)
        errorMsg.style.display = 'none';
    };

    const resetAuthModalHandler = (e) => {
        e.preventDefault();
        showAuthBlock(AUTH_BLOCKS.LOGIN);
        authWrapper?.classList.remove('no-bg');
        authWrapper?.classList.remove('success-msg');
        $("#message-template").addClass("hidden");
        $(".reset-pass-container").removeClass("hidden");
        resetAll();
    };

    $(document).on('click', '.js-toggle-auth-modal', resetAuthModalHandler);
};
